export default __webpack_public_path__ + "2356ce20ac524c5f2c5b28986c9a7862.png";